import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {useCallback, useState} from "react";
import {OtsAsyncThunkConfigExtra, OtsState} from "../store/ots-store";
import {removeUndefined} from "../util/util";
import {
  CompanyDisposalReport,
  CompanyDisposalReportCriteria,
  CompanyDisposalReportValidator
} from "../model/report/company-disposal-report";
import {validateJSON} from "../web/validation";
import {buildStandardHeaders} from "../store/ots-api";

export type UseDownloadCompanyDisposalReportProps = {
  baseQueryApi: BaseQueryApi
}

export type UseDownloadCompanyDisposalReportResult = {
  downloadCompanyDisposalReport: (criteria: CompanyDisposalReportCriteria) => void
  report?: CompanyDisposalReport
  error?: any
  loading: boolean
}

export const useDownloadCompanyDisposalReport = (props: UseDownloadCompanyDisposalReportProps): UseDownloadCompanyDisposalReportResult => {
  const {baseQueryApi} = props

  const [_report, _setReport] = useState<CompanyDisposalReport | undefined>(undefined)
  const [_error, _setError] = useState()
  const [_loading, _setLoading] = useState<boolean>(false)

  const _downloadCompanyDisposalReport = useCallback((criteria: CompanyDisposalReportCriteria) => {

    _setReport(undefined)
    _setLoading(true)
    _setError(undefined)

    const headers = buildStandardHeaders(baseQueryApi)
    headers["Accept"] = 'application/json'
    headers["Content-Type"] = 'application/json'

    const request: RequestInit = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(criteria),
    }

    const baseUrl = (baseQueryApi.extra as OtsAsyncThunkConfigExtra).baseUrl;
    const url = `${baseUrl}/reports/company-disposal`;

    window.fetch(url, request)
      .then((response) => {
        response.json()
          .then((json) => {
            validateJSON(CompanyDisposalReportValidator, json)
              .then((data) => {
                _setReport(data)
              })
              .catch((rejected) => {
                _setError(rejected)
              })
              .finally(() => {
                _setLoading(false)
              })
          })
          .catch((rejected) => {
            _setError(rejected)
            _setLoading(false)
          })
      })
      .catch((rejected) => {
        _setError(rejected)
        _setLoading(false)
      })
  }, [baseQueryApi])

  return {
    downloadCompanyDisposalReport: _downloadCompanyDisposalReport,
    report: _report,
    error: _error,
    loading: _loading,
  }
}
